import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import "../../src/assets/AdminCss/card.css";
import "../../src/assets/rules.css";
import MarqueeBottom from "./components/MarqueeBottom";

const Rules = () => {
  const [isSidebar, setSidebar] = useState(false);
  const [showCanvas, setShowCanvas] = useState(false);
  const [activeTab, setActiveTab] = useState("tab1");

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      // Start closed and let the visitor open it. Forcing it open
      // above 991px put a fixed panel over the page content.
      setSidebar(false);
    };
    handleResize();
  }, []);

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 991);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-toasts
          _ngcontent-jrx-c101=""
          aria-live="polite"
          aria-atomic="true"
          className="ngb-toasts"
        ></app-toasts>
        <router-outlet _ngcontent-jrx-c101=""></router-outlet>
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            {/* {isLargeScreen && <TopBar />} */}
            <Header
              isSidebar={isSidebar}
              setSidebar={setSidebar}
              show={showCanvas}
              handleShow={handleCanvasShow}
              handleClose={handleCanvasClose}
            />

            <div _ngcontent-jrx-c95="" className="body-container mb-5">
              <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "1100%",
                  paddingLeft: isLargeScreen ? "0px" : "0px",
                  transition: "width 0.3s ease-in-out",
                  backgroundColor: "var(--dark-theme-data-bg)",
                }}
              >

                <div className="d-flex justify-content-center pt-3 rules-lang">
                  <button
                    className={`flex-1 px-4 py-2 rounded-t-xl text-center font-semibold transition btn ${
                      activeTab === "tab1"
                        ? "bg-blue text-white"
                        : "bg-gray text-gray hover:bg-gray"
                    }`}
                    onClick={() => setActiveTab("tab1")}
                  >
                    English
                  </button>
                  <button
                    className={`flex-1 ms-3 px-4 py-2 rounded-t-xl text-center font-semibold transition btn ${
                      activeTab === "tab2"
                        ? "bg-blue text-white"
                        : "bg-gray text-gray hover:bg-gray"
                    }`}
                    onClick={() => setActiveTab("tab2")}
                  >
                    Hindi
                  </button>
                </div>

                {activeTab === "tab1" && 
                <div className="rules-container text-dark">
                  <h1 className="rules-title">
                    📜 Please Read Our Rules Before Placing Bet
                  </h1>
                  <p className="rules-note">
                    <strong>Note:</strong> Once our exchange gives username and
                    password, it is your responsibility to change the password.
                  </p>

                  <div className="rules-content">
                    <h2>1) SCORECARD RULES:</h2>
                    <p>
                      1.1 Live scores and other data on this site is sourced
                      from third party feeds and may be subject to time delays
                      and/or be inaccurate. If you rely on this data to place
                      bets, you do so at your own risk. Our exchange does not
                      accept responsibility for loss suffered as a result of
                      reliance on this data.
                    </p>
                    <p>
                      1.2 If Any Dispute in Fancy Results, then the Company
                      Decision Will be Final.
                    </p>

                    <h2>2) CHEAT RULES:</h2>
                    <p>
                      2.1 In Betfair & Fancy markets, If anyone is suspected
                      using ground commentary or ground line or courtsiding
                      (being in ground while betting), company will void all
                      winning bets (without providing any proof). This is a zero
                      tolerance policy and no arguments will be entertained. The
                      bets will be voided after the match is completed.
                      Company's decision will be final decision.
                    </p>

                    <h2>3) MATCH ODDS RULES:</h2>
                    <p>3.1 Cricket: We will follow Betfair result.</p>
                    <p>3.2 Soccer: We will follow Betfair result.</p>
                    <p>3.3 Tennis: We will follow Betfair result.</p>
                    <p>
                      3.4 IF Any Client Found Hedging Or Doing Manipulation in
                      Any Match Odds, then company has the right to Void the
                      Bets.
                    </p>
                    <p>
                      3.5 If Exchange resettle any bets or Markets due to wrong
                      Result Declaration or any other reason & if the Player has
                      lost Money or If Player gets Negative Balance, In this
                      case Company will do the Settlement from Agent for the
                      same, all decision will be Full And Final, No Arguments
                      will be listened.
                    </p>
                    <p>
                      3.6 Company reserves the right to void any bets (only
                      winning bets) of any event at any point of the match if
                      the company believes there is any cheating/wrong doing in
                      that particular event by the players (either
                      batsman/bowler)
                    </p>
                    <p>
                      3.7 If there is a super over then the match odds of the
                      Super Over will be settled after the Final result of
                      winner team is declared but in case of Bookmaker we will
                      Settle or Void the Particular super over Bookmaker Based
                      upon that Particular Markets Result
                    </p>

                    <h2>4) BOOK-MAKER MARKET RULES:</h2>
                    <p>
                      4.1 Due to any reason any team will be getting advantage
                      or disadvantage we are not concerned.
                    </p>
                    <p>
                      4.2 Wrong team selection by our mistake all back and lays
                      bets will be deleted.
                    </p>
                    <p>4.3 Wrong rate bets also voided.</p>
                    <p>
                      4.4 If Exchange resettle any bets or Markets due to wrong
                      Result Declaration or any other reason & if the Player has
                      lost Money or If Player gets Negative Balance, In this
                      case Company will do the Settlement from Agent for the
                      same, all decision will be Full And Final, No Arguments
                      will be listened.
                    </p>
                    <p>
                      4.5 Company reserves the right to void any bets (only
                      winning bets) of any event at any point of the match if
                      the company believes there is any cheating/wrong doing in
                      that particular event by the players (either
                      batsman/bowler)
                    </p>
                    <p>
                      4.6 If both the teams score same runs in 6,10,15 overs the
                      team that first bated will be declared as the winner.
                    </p>

                    <h2>5) FANCY:</h2>
                    <p>
                      5.1 Advance fancy: - Advance Session, Player Runs and all
                      Fancy Bets are only valid for 20 Over/50 over full match
                      each side. (Please Note this condition is applied only in
                      case of Advance Fancy Bets only).
                    </p>
                    <p>
                      5.2 All advance fancy bets market will be suspended 60
                      mins prior to match and will be settled.
                    </p>
                    <p>5.3 Advance session and Lambi 1st inning valid only.</p>
                    <p>
                      5.4 Total match playing over adv: - We Will Settle this
                      Market after Whole Match gets Completed.
                    </p>
                    <p>
                      5.5 Criteria: - We Will Count Only Round- Off Over For
                      Both the Innings While Settling...
                    </p>
                    <p>
                      5.6 In Case of Rain or if Over gets Reduced then this
                      Market will get Voided.
                    </p>

                    <p>
                      5.7) 3 Wkt or more by bowler in match adv:- We Will Settle
                      this Market after Whole Match gets Completed.
                    </p>
                    <p>
                      5.8) Once all session/fancy bets are completed and settled
                      there will be no reversal even if the Match is Tied or is
                      Abandoned.
                    </p>
                    <p>
                      5.9) Under the rules of Session/Fancy Bets if a market
                      gets Suspended for any reason whatsoever and does not
                      resume then all previous Bets will remain Valid and become
                      HAAR/JEET bets.
                    </p>
                    <p>
                      5.10) Incomplete Session/Fancy Bet will be cancelled but
                      Complete Session will be settled.
                    </p>
                    <p>
                      5.11) In the case of Running Match getting Cancelled/ No
                      Result/ Abandoned but the session is complete it will
                      still be settled. Player runs / fall of wicket/Wicket lost
                      to ball/How many ball face by player will be also settled
                      at the figures where match gets stopped due to rain for
                      the inning (D/L) , cancelled , abandoned , no result.
                    </p>
                    <p>
                      5.12) If a player gets Retired Hurt and one ball is
                      completed after you place your bets then all the betting
                      till then is and will remain valid.
                    </p>
                    <p>
                      5.13) Should a Technical Glitch in Software occur, we will
                      not be held responsible for any losses.
                    </p>
                    <p>
                      5.14) Should there be a power failure or a problem with
                      the Internet connection at our end and session/fancy
                      market does not get suspended then our decision on the
                      outcome is final.
                    </p>
                    <p>
                      5.15) All decisions relating to settlement of wrong market
                      being offered will be taken by management. Management will
                      consider all actual facts and decision taken will be full
                      in final.
                    </p>
                    <p>
                      5.16) Any bets which are deemed of being suspicious,
                      including bets which have been placed from the stadium or
                      from a source at the stadium maybe void at anytime. The
                      decision of whether to void the particular bet in question
                      or to void the entire market will remain at the discretion
                      of Company. The final decision of whether bets are
                      suspicious will be taken by Company and that decision will
                      be full and final.
                    </p>
                    <p>
                      5.17) Any sort of cheating bet, any sort of Matching
                      (Passing of funds), Court Siding (Ghaobaazi on
                      commentary), Sharpening, Commission making is not allowed
                      in Company, If any company User is caught in any of such
                      act then all the funds belonging that account would be
                      seized and confiscated. No argument or claim in that
                      context would be entertained and the decision made by
                      company management will stand as final authority.
                    </p>
                    <p>
                      5.18) If any case wrong rate has been given in fancy,that
                      particular bets will be cancelled (Wrong Commentary).
                    </p>
                    <p>
                      5.19) In case customer make bets in wrong fancy we are not
                      liable to delete, no changes will be made and bets will be
                      considered as confirm bet.
                    </p>
                    <p>
                      5.20) any query regarding result or rate has to be
                      contacted within 7 days from the event, query after 7 days
                      from the event will not be considered as valid.
                    </p>
                    <p>
                      5.21) The Rules Which we have added Regarding
                      Cheating/Hedging/manipulation of Odds are ONLY for the
                      Ones with Wrong Intensions Not for Genuine Clients.
                    </p>
                    <p>
                      5.22) Penalty Runs - Any Penalty Runs Awarded in the Match
                      (In Any Running Fancy or ADV Fancy) Will Not be Counted
                      While Settling in our Exchange.
                    </p>
                    <p>
                      5.23) Player Boundaries Fancy:- We will only consider
                      Direct Fours and Sixes hit by BAT.
                    </p>
                    <p>
                      5.24) Bowler run session rule:- If Bowler Bowl 1.1
                      over,then valid(For Bowler 2 over runs session) If Bowler
                      Bowl 2.1 over,then valid(For Bowler 3 over runs session)
                      If Bowler Bowl 3.1 over,then valid(For Bowler 4 over runs
                      session) If Bowler Bowl 4.1 over,then valid(For Bowler 5
                      over runs session) If Bowler Bowl 9.1 over,then valid(For
                      Bowler 10 over runs session)
                    </p>
                    <p>
                      5.25) Any cricket event which is being held behind closed
                      doors in that if any players found to be taking advantage
                      of groundline in fancy bets in such cases bets can be void
                      after the market ends. Company decision to be final.
                    </p>
                    <p>
                      5.26) Company reserves the right to suspend/void any
                      id/bets if the same is found to be illegitimate. For
                      example,In case of VPN/robot-use/multiple entry from same
                      IP/ multiple bets at same time (Punching) and others.
                      Note: - only winning bets will be voided, For example: If
                      we find such entries (above mentioned) from any id and
                      their bets are (200000 lay in a 6 over session for the
                      rate 40 and 200000 back for the rate of 48) and the actual
                      score is 38, bets of 40 lay will be voided and the bets
                      for 48 back will be considered valid.
                    </p>
                    <p>
                      5.27) Odd-even rules:- Incomplete games will be deleted.
                      Over reduced or abandoned all bets will be deleted.
                    </p>
                    <p>
                      5.28) In any circumstances company decision will be final.
                    </p>
                    <p>
                      5.29) If Users Found Betting In Group's then We Will Void
                      "Only The Winning Bets of the Users" and Company Decision
                      Will be Full and Final.
                    </p>
                    <p>
                      5.30) If Exchange resettle any bets or Markets due to
                      wrong Result Declaration or any other reason & if the
                      Player has lost Money or If Player gets Negative Balance,
                      In this case Company will do the Settlement from Agent for
                      the same, all decision will be Full And Final, No
                      Arguments will be listened.
                    </p>
                    <p>
                      5.31) Company reserves the right to void any bets (only
                      winning bets) of any event at any point of the match if
                      the company believes there is any cheating/wrong doing in
                      that particular event by the players (either
                      batsman/bowler)
                    </p>
                    <p>
                      5.32) Total match 30s Adv:- 50 or 100 not counted in this
                      event ( Ex. In this event 30 Runs to 49 Runs counted)
                    </p>
                    <p>
                      5.33) Total match 50s adv :- 100 not counted in this event
                      ( Ex. In this event 50 Runs to 99 Runs counted)
                    </p>
                    <p>5.34) Our Exchange Is Trusted and Fair.</p>
                    <p>
                      5.35) 5.35.1) TOTAL MATCH RUNS - If Over reduces because
                      of rain or any other reason ( either in 1st or 2nd
                      innings) whole market will get voided.
                    </p>
                    <p>
                      5.35.2) In the Total Match Runs market, if the TV
                      scoreboard changes after the innings break in a live
                      match, we will declare the fancy's result based on the
                      live match's offered rate. For example, if Australia
                      scored 185 runs in their first innings, but England's
                      target was revised to 183 in the second innings, and
                      England scored 170 runs, the Total Match Runs market
                      result will be 185 + 170 = 355 runs.
                    </p>
                    <p>
                      5.36) Retired out or Retired hurt is not considered as
                      wicket.
                    </p>
                    <p>
                      5.37) Middle session and Session is not completed due to
                      Innings declared or all out so that particular over
                      considered as completed and remaining over counted in next
                      team Innings for ex:- In case of Innings declared or all
                      out In 131.5th over Considered as 132 over completed
                      remaining 1 over counted for 133 over middle session and 3
                      over counted for 135 over session from next team Innings
                      and One over session and Only over session is not
                      completed due to innings declared so that Particular over
                      session bets will be deleted and all out considered as
                      valid for ex:- In case of Innings declared In 131.5th over
                      so 132 over will be deleted and if all out then 132 over
                      and Only 132 over will be Valid.
                    </p>
                    <p>
                      5.38) Total Match Four Hitters : Number of Batsman hitting
                      Fours in full match.
                    </p>
                    <p>
                      5.39) Total Match Six Hitters : Number of Batsman hitting
                      Sixes in full match.
                    </p>
                    <p>
                      5.40) Total Match Wicket Takers : Number of bowlers taking
                      wickets in full match.
                    </p>
                    <p>
                      5.41) Total No Boundaries overs : Batsman bat boundaries
                      only considered
                    </p>
                    <p>
                      5.42) 1st Inn Total Dot Balls : Only No run will count as
                      dot ball.. If wicket means that will not count as dot
                      ball.
                    </p>

                    <h2>6) IPL RULES:</h2>
                    <p>
                      6.1) If Over Reduced in Match, we will not count the
                      actual scores of the Over Reduced Matches instead we will
                      count the Market’s Average Scores.
                    </p>
                    <p>
                      6.2) If Match is Abandoned, we will not count the actual
                      scores of the Abandoned Matches instead we will count the
                      Market’s Average Scores. NOTE:-These rules are for the
                      following Markets of ENTIRE IPL 2021 (60 Matches):-
                    </p>
                    <p>
                      6.3) Total Fours: - Average 26 Fours will be given if the
                      match is abandoned or over reduced.
                    </p>
                    <p>
                      6.4) Total Sixes: - Average 13 Sixes will be given if the
                      match is abandoned or over reduced.
                    </p>
                    <p>
                      6.5) Total Wide: - Average 8 Wide’s will be given if the
                      match is abandoned or over reduced.
                    </p>
                    <p>
                      6.6) Total Extras: - Average 14 Extras will be given if
                      the match is abandoned or over reduced.
                    </p>
                    <p>
                      6.7) Total No Ball: - Average 1 No Ball will be given if
                      the match is abandoned or over reduced.
                    </p>
                    <p>
                      6.8) Total Duck: - Average 1 Duck will be given if the
                      match is abandoned or over reduced.
                    </p>
                    <p>
                      6.9) Total Fifties: - Average 2 Fifties will be given if
                      the match is abandoned or over reduced.
                    </p>
                    <p>
                      6.10) Total Century: - Average 0 Century will be given if
                      the match is abandoned or over reduced.
                    </p>
                    <p>
                      6.11) Total Run Out: - Average 1 Run Out will be given if
                      the match is abandoned or over reduced.
                    </p>
                    <p>
                      6.12) Total Caught out: - Average 8 Caught Out will be
                      given if the match is abandoned or over reduced.
                    </p>
                    <p>
                      6.13) Total Maiden Over: - Average 0 Maiden Over will be
                      given if the match is abandoned or over reduced.
                    </p>
                    <p>
                      6.14) Total LBW: - Average 1 LBW will be given if the
                      match is abandoned or over reduced.
                    </p>
                    <p>
                      6.15) Total Bowled: - Average 2 Bowled will be given if
                      the match is abandoned or over reduced.
                    </p>
                    <p>
                      6.16) In case IPL Matches Gets Stopped or Interrupted Due
                      to "COVID-19" or Any "ACT OF GOD" Reasons, under 45
                      Matches then All IPL 2021 Tournament Fancy Markets will be
                      Voided, but if 45 or Above Matches are Being Played then
                      we will Settle all the Fancy Markets and Also If there are
                      NON-Played Matches Above 45 then we will settle the
                      markets as per our Markets Average.
                    </p>
                    <p>
                      6.17) If IPL 2021 gets stopped due to “Covid-19” or Any
                      “Act of God” reason then We will wait till 45 days from
                      the day IPL gets stopped, and if IPL Matches gets Resumed
                      before 45th day then we will continue as Usual Score
                      Countation but if IPL 2021 does not resume until 45th day
                      then we will settle the markets according to our
                      above-mentioned Markets Averages and In case of Void, We
                      will Void the under 45 matches on 45th day from the day
                      IPL 2021 stopped.
                    </p>

                    <h2>7) CASINO RULES:</h2>
                    <p>
                      7.1) If Company voided any bet due to wrong rate or
                      technical issue in casino games and the Player has lost
                      Money or If Player gets Negative Balance, In this case
                      Company will do the Settlement from Agent for the same,
                      all decision will be Full And Final, No Arguments will be
                      listened.
                    </p>

                    <p>7.2) Exchange accept maximum bet as per below casino:</p>
                    <p>Evolution: 2,00,000 INR</p>
                    <p>Pragmatic: 2,00,000 INR</p>
                    <p>Bet Games: 2,00,000 INR</p>
                    <p>Vivo: 2,00,000 INR</p>
                    <p>Ezugi: 2,00,000 INR</p>
                    <p>Other: 2,00,000 INR</p>

                    <h2>8) SOCCER RULES:</h2>
                    <p>
                      8.1) Here comes the VAR verdict. NO GOAL for Ecuador due
                      to an offside in the build-up play.
                    </p>

                    <h2>9) LOTTERY RULES:-</h2>
                    <p>9.1) Lottery means Last Digit.</p>
                    <p>
                      9.2) Completed Lottery Will be Settled, Incomplete Lottery
                      Will be voided.
                    </p>
                    <p>
                      9.3) Example :- We will Count Last Digit of particular
                      Lottery Market, if in 6 over Market the Score is 42, so we
                      will settle that particular market @ 2.
                    </p>
                    <p>
                      9.4) In case of Rain or If Over Gets Reduced then this
                      Market will get Voided.
                    </p>

                    <h2>10) TENNIS RULES:-</h2>
                    <p>
                      10.1) In tennis if First set is not completed and the
                      player is injured..and he does not play the game...then
                      the opposite player will be given the winner.
                    </p>

                    <h2>11) RUN DIFFERENT:</h2>
                    <p>
                      If both teams have the same score, the team that scored
                      the most runs using the fewest number of balls will be
                      declared the winner.
                    </p>
                    <p>
                      In this market, the team with the higher total runs based
                      on selected player positions will be declared the winner.
                    </p>
                    <p>For example:</p>
                    <p>Team 1: (IND1 + IND3 + AUS2 + AUS4)</p>
                    <p>Team 2: (IND2 + IND4 + AUS1 + AUS3)</p>
                    <p>
                      This means Team 1’s total is the sum of runs scored by
                      India’s 1st batter, India’s 3rd batter, Australia’s 2nd
                      batter, and Australia’s 4th batter.
                    </p>
                    <p>
                      Team 2’s total is the sum of runs scored by India’s 2nd
                      batter, India’s 4th batter, Australia’s 1st batter, and
                      Australia’s 3rd batter.
                    </p>
                    <p>
                      The team with the higher total run from these selected
                      players will be declared the winner.
                    </p>
                    <p>
                      NOTE :- In this situation, if both the runs and the number
                      of balls faced by the two teams are equal, then the team
                      with the highest number of boundaries will be declared the
                      winner.
                    </p>
                    <p>
                      For example :- ( TEAM - 1 ) has 10 boundaries and ( TEAM -
                      2 ) has 12 boundaries then ( TEAM - 2 ) becomes the
                      winner.
                    </p>
                  </div>
                </div>
                }

                {activeTab === "tab2" && 
                <div className="rules-container text-dark">
                  <h1 className="rules-title">
                    📜 कृपया बेट लगाने से पहले हमारे नियम पढ़ें
                  </h1>
                  <p className="rules-note">
                    <strong>नोट:</strong> एक बार हमारे एक्सचेंज से उपयोगकर्ता
                    नाम और पासवर्ड मिलने के बाद, पासवर्ड बदलना आपकी जिम्मेदारी
                    है।
                  </p>

                  <div className="rules-content">
                    <h2>1) स्कोरकार्ड नियम:</h2>
                    <p>
                      1.1 इस साइट पर लाइव स्कोर और अन्य डेटा थर्ड पार्टी फीड्स
                      से लिया गया है और इसमें समय में देरी या गलतियां हो सकती
                      हैं। यदि आप इस डेटा पर भरोसा करके बेट लगाते हैं, तो यह
                      आपका जोखिम है। हमारे एक्सचेंज को इस डेटा पर भरोसा करने के
                      कारण होने वाले नुकसान की कोई जिम्मेदारी नहीं है।
                    </p>
                    <p>
                      1.2 यदि फैंसी परिणाम में कोई विवाद है, तो कंपनी का निर्णय
                      अंतिम होगा।
                    </p>

                    <h2>2) धोखाधड़ी नियम:</h2>
                    <p>
                      2.1 बेटफेयर और फैंसी मार्केट में, यदि कोई ग्राउंड
                      कमेंट्री, ग्राउंड लाइन या कोर्टसाइडिंग (मैच के दौरान मैदान
                      में होना) का उपयोग करता पाया जाता है, तो कंपनी सभी जीतने
                      वाले बेट्स को रद्द कर देगी। यह शून्य सहनशीलता नीति है और
                      कोई तर्क नहीं सुने जाएंगे। मैच के बाद बेट्स रद्द किए
                      जाएंगे। कंपनी का निर्णय अंतिम होगा।
                    </p>

                    <h2>3) मैच ऑड्स नियम:</h2>
                    <p>3.1 क्रिकेट: हम बेटफेयर परिणाम का पालन करेंगे।</p>
                    <p>3.2 सॉकर: हम बेटफेयर परिणाम का पालन करेंगे।</p>
                    <p>3.3 टेनिस: हम बेटफेयर परिणाम का पालन करेंगे।</p>
                    <p>
                      3.4 यदि कोई ग्राहक हेजिंग या किसी भी मैच ऑड्स में हेरफेर
                      करता पाया जाता है, तो कंपनी को बेट्स रद्द करने का अधिकार
                      होगा।
                    </p>
                    <p>
                      3.5 यदि एक्सचेंज किसी परिणाम को गलत घोषित करने या किसी
                      अन्य कारण से बेट्स को फिर से सेट करता है और खिलाड़ी का
                      पैसा खो जाता है या नकारात्मक बैलेंस होता है, तो कंपनी
                      एजेंट से ही निपटान करेगी। निर्णय अंतिम और अपरिवर्तनीय
                      होगा।
                    </p>
                    <p>
                      3.6 यदि कंपनी को किसी खिलाड़ी द्वारा धोखाधड़ी या गलत काम
                      का संदेह है, तो किसी भी समय केवल जीतने वाले बेट्स को रद्द
                      करने का अधिकार सुरक्षित है।
                    </p>
                    <p>
                      3.7 सुपर ओवर होने पर, सुपर ओवर का परिणाम अंतिम टीम के
                      परिणाम घोषित होने के बाद तय होगा। बुकमेकर के मामले में
                      विशेष मार्केट परिणाम के अनुसार बेट्स को सेटेल या रद्द किया
                      जाएगा।
                    </p>

                    <h2>4) बुकमेकर मार्केट नियम:</h2>
                    <p>
                      4.1 किसी भी कारण से किसी टीम को फायदा या नुकसान होने पर
                      कंपनी जिम्मेदार नहीं है।
                    </p>
                    <p>
                      4.2 हमारी गलती से गलत टीम चयन होने पर सभी बेट्स रद्द कर
                      दिए जाएंगे।
                    </p>
                    <p>4.3 गलत दर वाले बेट्स भी रद्द होंगे।</p>
                    <p>
                      4.4 यदि एक्सचेंज किसी परिणाम को गलत घोषित करने या किसी
                      अन्य कारण से बेट्स को फिर से सेट करता है और खिलाड़ी का
                      पैसा खो जाता है या नकारात्मक बैलेंस होता है, तो कंपनी
                      एजेंट से ही निपटान करेगी। निर्णय अंतिम और अपरिवर्तनीय
                      होगा।
                    </p>
                    <p>
                      4.5 कंपनी को किसी भी समय केवल जीतने वाले बेट्स को रद्द
                      करने का अधिकार सुरक्षित है यदि कंपनी को धोखाधड़ी का संदेह
                      है।
                    </p>
                    <p>
                      4.6 यदि दोनों टीमों ने समान रन बनाए तो पहले बल्लेबाजी करने
                      वाली टीम को विजेता घोषित किया जाएगा।
                    </p>

                    <h2>5) फैंसी:</h2>
                    <p>
                      5.1 एडवांस फैंसी: एडवांस सेशन, खिलाड़ी रन और सभी फैंसी
                      बेट्स केवल 20/50 ओवर मैच के लिए मान्य हैं। (यह शर्त केवल
                      एडवांस फैंसी बेट्स के लिए लागू होती है।)
                    </p>
                    <p>
                      5.2 सभी एडवांस फैंसी बेट्स मैच से 60 मिनट पहले सस्पेंड कर
                      दिए जाएंगे।
                    </p>
                    <p>5.3 एडवांस सेशन और लंबी 1वीं इनिंग मान्य है।</p>
                    <p>
                      5.4 टोटल मैच ओवर एडवांस: मैच के पूरा होने के बाद ही यह
                      मार्केट सेटेल किया जाएगा।
                    </p>
                    <p>5.5 केवल पूर्ण ओवर की गिनती की जाएगी।</p>
                    <p>5.6 बारिश या ओवर कम होने पर मार्केट रद्द किया जाएगा।</p>
                    <p>
                      5.7) 3 विकेट या अधिक लेने वाले गेंदबाज मार्केट मैच खत्म
                      होने के बाद सेटेल होगा।
                    </p>
                    <p>
                      5.8 सभी सेशन/फैंसी बेट्स पूरा होने और सेटेल होने के बाद
                      कोई रिवर्सल नहीं होगा।
                    </p>
                    <p>
                      5.9 यदि मार्केट किसी कारण से सस्पेंड हो जाता है और शुरू
                      नहीं होता, तो पिछले सभी बेट्स वैध रहेंगे।
                    </p>
                    <p>
                      5.10 अधूरा सेशन/फैंसी बेट रद्द किया जाएगा लेकिन पूरा सेशन
                      सेटेल होगा।
                    </p>
                    <p>
                      5.11 रद्द/कोई परिणाम नहीं/परित्यक्त मैच में सेशन पूरा होने
                      पर भी सेटेल होगा।
                    </p>
                    <p>
                      5.12 यदि खिलाड़ी चोटिल होकर रिटायर होता है और एक गेंद
                      पूर्ण होने के बाद बेट लगाई गई है, तो बेट वैध रहेगी।
                    </p>
                    <p>5.13 तकनीकी गड़बड़ी के लिए कंपनी जिम्मेदार नहीं होगी।</p>
                    <p>
                      5.14 पावर फेल्योर या इंटरनेट समस्या के मामले में निर्णय
                      अंतिम होगा।
                    </p>
                    <p>
                      5.15 गलत मार्केट का निपटान प्रबंधन द्वारा अंतिम रूप से
                      किया जाएगा।
                    </p>
                    <p>5.16 संदिग्ध बेट्स रद्द किए जा सकते हैं।</p>
                    <p>
                      5.17 धोखाधड़ी, मैचिंग, कोर्टसाइडिंग, कमीशन बनाने की अनुमति
                      नहीं है।
                    </p>
                    <p>5.18 गलत फैंसी दर पर बेट रद्द की जाएगी।</p>
                    <p>
                      5.19 गलत फैंसी में बेट्स की जिम्मेदारी ग्राहक की होगी।
                    </p>
                    <p>
                      5.20 परिणाम/दर संबंधी प्रश्न 7 दिन के भीतर किए जाने चाहिए।
                    </p>
                    <p>
                      5.21 धोखाधड़ी/हेजिंग नियम केवल गलत इरादे वाले ग्राहकों के
                      लिए हैं।
                    </p>
                    <p>5.22 पेनल्टी रन्स को सेटेलमेंट में नहीं गिना जाएगा।</p>
                    <p>
                      5.23 खिलाड़ी की बाउंड्री फैंसी में केवल फोर और सिक्स गिने
                      जाएंगे।
                    </p>
                    <p>5.24 गेंदबाज रन सेशन नियम लागू।</p>
                    <p>
                      5.25 बंद दरवाजे वाले मैच में फैंसी बेट्स रद्द किए जा सकते
                      हैं।
                    </p>
                    <p>
                      5.26 VPN/रॉबोट/मल्टीपल एंट्री जैसी गतिविधियों पर केवल
                      जीतने वाले बेट्स रद्द होंगे।
                    </p>
                    <p>
                      5.27 अधूरे गेम्स रद्द होंगे, ओवर कम या रद्द होने पर बेट्स
                      रद्द होंगे।
                    </p>
                    <p>5.28 कंपनी का निर्णय अंतिम होगा।</p>
                    <p>
                      5.29 समूह में बेटिंग करने पर केवल जीतने वाले बेट्स रद्द
                      होंगे।
                    </p>
                    <p>5.30 नकारात्मक बैलेंस होने पर एजेंट से निपटान होगा।</p>
                    <p>
                      5.31 धोखाधड़ी/गलत काम पर केवल जीतने वाले बेट्स रद्द होंगे।
                    </p>
                    <p>
                      5.32 टोटल मैच 30s एडवांस में 50 या 100 रन नहीं गिने
                      जाएंगे।
                    </p>
                    <p>5.33 टोटल मैच 50s एडवांस में 100 रन नहीं गिने जाएंगे।</p>
                    <p>5.34 हमारा एक्सचेंज भरोसेमंद और निष्पक्ष है।</p>
                    <p>5.35 ओवर कम होने पर टोटल रन मार्केट रद्द होगा।</p>
                    <p>
                      5.36 रिटायर्ड/रिटायर्ड हर्ट विकेट में नहीं गिना जाएगा।
                    </p>
                    <p>5.37 मध्य सेशन अधूरा होने पर विशेष ओवर सेटेल या रद्द।</p>
                    <p>
                      5.38 टोटल मैच फोर हिटर: फोर हिट करने वाले बल्लेबाज की
                      संख्या।
                    </p>
                    <p>
                      5.39 टोटल मैच सिक्स हिटर: सिक्स हिट करने वाले बल्लेबाज की
                      संख्या।
                    </p>
                    <p>
                      5.40 टोटल मैच विकेट टेकर्स: विकेट लेने वाले गेंदबाजों की
                      संख्या।
                    </p>
                    <p>
                      5.41 नो बाउंड्री ओवर: केवल बाउंड्री वाले रन गिने जाएंगे।
                    </p>
                    <p>5.42 1st इनिंग डॉट बॉल: केवल नो रन डॉट बॉल मान्य।</p>

                    <h2>6) IPL नियम:</h2>
                    <p>
                      6.1 ओवर कम होने पर वास्तविक स्कोर की बजाय मार्केट का औसत
                      स्कोर लिया जाएगा।
                    </p>
                    <p>
                      6.2 मैच रद्द होने पर वास्तविक स्कोर की बजाय मार्केट का औसत
                      स्कोर लिया जाएगा।
                    </p>
                    <p>6.3 टोटल फोर: औसत 26 फोर।</p>
                    <p>6.4 टोटल सिक्स: औसत 13 सिक्स।</p>
                    <p>6.5 टोटल वाइड: औसत 8 वाइड।</p>
                    <p>6.6 टोटल एक्स्ट्रा: औसत 14।</p>
                    <p>6.7 टोटल नो बॉल: औसत 1।</p>
                    <p>6.8 टोटल डक: औसत 1।</p>
                    <p>6.9 टोटल फिफ्टी: औसत 2।</p>
                    <p>6.10 टोटल सेंचुरी: औसत 0।</p>
                    <p>6.11 टोटल रन आउट: औसत 1।</p>
                    <p>6.12 टोटल कैच आउट: औसत 8।</p>
                    <p>6.13 टोटल मेडेन ओवर: औसत 0।</p>
                    <p>6.14 टोटल LBW: औसत 1।</p>
                    <p>6.15 टोटल बोल्ड: औसत 2।</p>
                    <p>
                      6.16 45 मैच से कम होने पर फैंसी मार्केट रद्द, 45 या अधिक
                      होने पर औसत के अनुसार सेटेल।
                    </p>
                    <p>
                      6.17 IPL 2021 रद्द होने पर 45 दिन इंतजार, उसके बाद औसत
                      मार्केट के अनुसार सेटेल।
                    </p>

                    <h2>7) कैसीनो नियम:</h2>
                    <p>
                      7.1 तकनीकी कारण या गलत दर पर रद्द बेट्स का निपटान एजेंट से
                      होगा, निर्णय अंतिम।
                    </p>
                    <p>7.2 अधिकतम बेट:</p>
                    <p>इवोल्यूशन: 2,00,000 INR</p>
                    <p>प्रागमैटिक: 2,00,000 INR</p>
                    <p>बेट गेम्स: 2,00,000 INR</p>
                    <p>वीवो: 2,00,000 INR</p>
                    <p>इज़ुई: 2,00,000 INR</p>
                    <p>अन्य: 2,00,000 INR</p>

                    <h2>8) सॉकर नियम:</h2>
                    <p>8.1 VAR निर्णय: इक्वाडोर का गोल ऑफसाइड के कारण नहीं।</p>

                    <h2>9) लॉटरी नियम:</h2>
                    <p>9.1 लॉटरी का अर्थ है अंतिम अंक।</p>
                    <p>9.2 पूरी लॉटरी सेटेल होगी, अधूरी रद्द होगी।</p>
                    <p>
                      9.3 उदाहरण: 6 ओवर मार्केट में स्कोर 42, मार्केट @2 पर
                      सेटेल।
                    </p>
                    <p>9.4 बारिश या ओवर कम होने पर मार्केट रद्द।</p>

                    <h2>10) टेनिस नियम:</h2>
                    <p>
                      10.1 यदि पहला सेट पूरा नहीं और खिलाड़ी चोटिल है, तो विरोधी
                      विजेता घोषित होगा।
                    </p>

                    <h2>11) रन डिफरेंट:</h2>
                    <p>
                      यदि दोनों टीमों का स्कोर समान है, तो जो टीम कम गेंदों में
                      अधिक रन बनाएगी, विजेता होगी।
                    </p>
                    <p>
                      इस मार्केट में चयनित खिलाड़ियों के आधार पर अधिक रन बनाने
                      वाली टीम विजेता होगी।
                    </p>
                    <p>उदाहरण:</p>
                    <p>टीम 1: (IND1 + IND3 + AUS2 + AUS4)</p>
                    <p>टीम 2: (IND2 + IND4 + AUS1 + AUS3)</p>
                    <p>
                      टीम 1 के कुल रन: भारत के 1 और 3 बल्लेबाज + ऑस्ट्रेलिया के
                      2 और 4 बल्लेबाज
                    </p>
                    <p>
                      टीम 2 के कुल रन: भारत के 2 और 4 बल्लेबाज + ऑस्ट्रेलिया के
                      1 और 3 बल्लेबाज
                    </p>
                    <p>
                      जो टीम चयनित खिलाड़ियों के अधिक रन बनाएगी, विजेता होगी।
                    </p>
                    <p>
                      नोट: यदि रन और गेंदें समान हों, तो अधिक बाउंड्री वाली टीम
                      विजेता होगी।
                    </p>
                    <p>
                      उदाहरण: टीम 1 के 10 बाउंड्री, टीम 2 के 12 बाउंड्री → टीम 2
                      विजेता।
                    </p>
                  </div>
                </div>
                }

                {/* <Footer /> */}
              </div>
            </div>
            <MarqueeBottom onMenuClick={handleCanvasShow} />
          </div>
        </app-landing-page-new>

        <div className="slider-container"></div>
      </div>
    </app-root>
  );
};

export default Rules;
